// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';          // <-- Tailwind directives here
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ToastContainer } from 'react-toastify';
import { reportWebVitals } from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import amplifyOutputs from './amplify_outputs.json';

// Logging configuration for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('Running in development mode');
  // Uncomment the following line if you want to see all AWS calls
  // localStorage.setItem('AMPLIFY_LOGS', 'DEBUG');
}

// Configure Amplify and start app
(async () => {
  try {
    // Import fetchAuthSession for REST API headers
    const { fetchAuthSession } = await import('aws-amplify/auth');
    
    // For Amplify v6 Gen 2, configure with the proper structure
    const config = {
      Auth: {
        Cognito: {
          userPoolId: amplifyOutputs.auth.user_pool_id,
          userPoolClientId: amplifyOutputs.auth.user_pool_client_id,
          region: amplifyOutputs.auth.aws_region,
          identityPoolId: amplifyOutputs.auth.identity_pool_id,
          allowGuestAccess: amplifyOutputs.auth.unauthenticated_identities_enabled || false
        }
      },
      API: {
        REST: {
          CourseBookingApi: {
            endpoint: amplifyOutputs.custom.API.CourseBookingHttpApi.endpoint,
            region: amplifyOutputs.custom.API.CourseBookingHttpApi.region,
            custom_header: async () => {
              try {
                const session = await fetchAuthSession();
                if (session?.tokens?.idToken) {
                  return {
                    Authorization: `Bearer ${session.tokens.idToken.toString()}`
                  };
                }
                return {};
              } catch (err) {
                console.error('Auth header error:', err);
                return {};
              }
            }
          }
        }
      }
    };
    
    console.log('🔧 Configuring Amplify in index.js with Auth and API');
    Amplify.configure(config);
    console.log('✅ Amplify configured successfully');

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <ToastContainer position="bottom-right" autoClose={3000} />
          </AuthProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('❌ Failed to configure Amplify:', error);
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();